import { render, staticRenderFns } from "./Members2022.vue?vue&type=template&id=5dbc6d43&scoped=true"
import script from "./Members2022.vue?vue&type=script&lang=js"
export * from "./Members2022.vue?vue&type=script&lang=js"
import style0 from "./Members2022.vue?vue&type=style&index=0&id=5dbc6d43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc6d43",
  null
  
)

export default component.exports